const collectObjValues = (
  object: { [key: string]: any },
  excludeKeys: string[] = []
): string[] => {
  const collectedValues: string[] = [];

  if (object !== null && typeof object === 'object') {
    const goDeeper = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(excludeKeys) ?? !excludeKeys.includes(key)) {
          if (
            value !== null
            && typeof value === 'object'
            && !Array.isArray(value)
          ) {
            goDeeper(value);
          } else {
            collectedValues.push(value as any);
          }
        }
      });
    };

    goDeeper(object);
  }

  return collectedValues;
};

export default collectObjValues;
